import { render, staticRenderFns } from "./newselectphonenum.vue?vue&type=template&id=4213d78a&scoped=true"
import script from "./newselectphonenum.vue?vue&type=script&lang=js"
export * from "./newselectphonenum.vue?vue&type=script&lang=js"
import style0 from "./newselectphonenum.vue?vue&type=style&index=0&id=4213d78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4213d78a",
  null
  
)

export default component.exports